module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('el-button', {
    staticStyle: {
      "margin": "20px 0px"
    },
    attrs: {
      "type": "primary",
      "plain": "",
      "icon": "el-icon-plus",
      "size": "mini"
    }
  }, [_vm._v("今日数据")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.list,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "登录人数",
      "align": "center",
      "prop": "loginNumber"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收礼人数",
      "align": "center",
      "prop": "receiveGiftsNumber"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "20px 0px"
    },
    attrs: {
      "type": "primary",
      "plain": "",
      "icon": "el-icon-plus",
      "size": "mini"
    }
  }, [_vm._v("本周数据")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.wList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "登录人数",
      "align": "center",
      "prop": "loginNumber"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收礼人数",
      "align": "center",
      "prop": "receiveGiftsNumber"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "20px 0px"
    },
    attrs: {
      "type": "primary",
      "plain": "",
      "icon": "el-icon-plus",
      "size": "mini"
    }
  }, [_vm._v("本月数据")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.mList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "登录人数",
      "align": "center",
      "prop": "loginNumber"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收礼人数",
      "align": "center",
      "prop": "receiveGiftsNumber"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-207a16d7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/chengyuantongji.vue
// module id = 616
// module chunks = 1